import React, { useEffect, useState } from "react"
import AdminDialog from "./AdminDialog"
import { TextBox, Validator } from "devextreme-react";
import { useSelector } from "react-redux";
import { selectServices } from "../../redux/services/selectors";
import { RoleInput } from "./RoleInput";
import { generate } from "generate-password-browser";
import { selectRoles } from "../../redux/roles/selectors";
import {selectUserRoles} from "../../redux/authentication/selectors"
import { Button, Divider, Typography } from "@material-ui/core";
import addIcon from "../../images/add-icon-white.svg"
import { useTranslation } from "react-i18next";
import { EmailRule } from "devextreme-react/validator";

const initialData={
    userName: "",
    email: "",
    roles: [{roleId: null, roleLevel: 0, serviceIds: [], externalId: generate({length: 8}) }]
}

function UserDialogue(props)
{
    const { t } = useTranslation();
    const {open, data, handleDialogClose, title, onSubmitOperation, operation} = props;
    const [editData, setEditData] = useState(initialData)
    const allRoles = useSelector(selectRoles)
    const allServices = useSelector(selectServices)
    const userRoles = useSelector(selectUserRoles)
    const userLevel = Math.max(...userRoles.map(role=> role.role.level))
    const allowedRoles = allRoles.filter(role=> role.level <= userLevel)

    useEffect(()=>{
        if(open && data){
            const roles = data.roles.map(role=> ({roleId: role.roleId, level: role.role?.level, externalId: generate({length: 8}), serviceIds: role.services.map(service=> service.serviceId)}))
            setEditData({userName: data.userName, email: data.email, userId: data.userId, roles})
        } else {
            setEditData(initialData)
        }
    
    },[data, open])


    function handleChangeRoleService(updatedRoleService){
       const updatedData = editData.roles.map(role=> role.externalId === updatedRoleService.externalId ? updatedRoleService : role );
       setEditData(prevState=> ({...prevState, roles: updatedData}))
    }

    function handleAddRole(){
        const newRole = {roleId: null, serviceIds: [], externalId: generate({length: 8}) }
        const updatedData = [...editData.roles, newRole];
        setEditData(prevState=> ({...prevState, roles: updatedData}))
    }

    function handleDeleteRole(externalId){
        const withoutRole = editData.roles.filter(role=> role.externalId !== externalId)
        setEditData(prevState=>({...prevState, roles: withoutRole}))
    }

    function handleChangeUserName(value){
        setEditData(prevState=>({...prevState, userName: value}))
    }

    function handleChangeEmail(value){
        setEditData(prevState=>({...prevState, email: value}))
    }

    function handleChangePassword(value){
        setEditData(prevState=>({...prevState, password: value}))
    }

    return(
        <AdminDialog dialogSize={{height: "100%"}} operation = { operation } open ={open} onClose = { handleDialogClose } title = {title} handleOnClick = { ()=>onSubmitOperation(operation, editData) }>
            {operation === "delete" ? 
                <Typography>
                    {`Você realmente deseja excluir este usuário "${editData.userName}"?`}
                </Typography>
            :
            <>
                <div style={{display: "flex", flexFlow: "column", gap: ".5rem"}}>
                    <TextBox label="Nome do Usuário" labelMode="floating" value={editData.userName} onValueChanged={event => handleChangeUserName(event.value)}/>
                    
                    <TextBox mode="email" key={"email"} disabled={operation === "edit"} label="E-mail" labelMode="floating" value={editData.email} onValueChanged={event => handleChangeEmail(event.value)}>
                        <Validator>
                            <EmailRule message="Formato de e-mail inválido" />
                        </Validator>
                    </TextBox>
                    
                    {operation === "create" &&
                        <TextBox mode="password" label="Senha" labelMode="floating" value={editData.password} onValueChanged={event=>handleChangePassword(event.value)}/>
                    }

                    {/* <Divider/> */}
                    <div style={{display: "flex", alignItems: "flex-end", fontWeight: "700", justifyContent: "space-between", marginTop: "1rem", marginBottom: "1rem"}}>
                        <div style={{color: "#333" }} >Roles</div>
                        <div><Button size="small" variant="contained" color="primary" startIcon={<img src={addIcon}/>} disabled={editData.roles.length === allowedRoles.length || editData.roles.some(role=> role.roleId === null)} onClick={handleAddRole}>Adicionar Role</Button></div>
                    </div>
                    <div style={{display: "flex", flexDirection: "column", rowGap: "0.5rem"}}>
                        { editData.roles.map((role, index)=> <RoleInput userLevel={userLevel} index={index} handleDeleteRole={handleDeleteRole} key={role.externalId} usedRoles={editData.roles} data={role} roles={allRoles} services={allServices} handleChangeValue={handleChangeRoleService}/>)}
                    </div>
                </div>
            </>
        }
        </AdminDialog>
    )

}

export {UserDialogue}